import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ spacing }) => ({
    circular: {
        width: "24px !important",
        height: "24px !important",
        marginLeft: -12,
        marginTop: -12,
        position: "absolute",
        top: "50%",
        left: "50%",
        ".MuiButton-sizeSmall &": {
            width: "16px !important",
            height: "16px !important",
            marginLeft: -8,
            marginTop: -8,
        },
    },
    button: {
        justifyContent: ({ align }) => align === "left"
            ? "flex-start"
            : align === "right"
                ? "flex-end"
                : "center",
        marginBottom: ({ gutterBottom }) => (gutterBottom ? spacing(2) : undefined),
        marginRight: ({ gutterRight }) => (gutterRight ? spacing(1) : undefined),
    },
    button__text: {
        color: ({ textColor }) => textColor &&
            {
                inherit: "inherit",
                black: "#000000",
            }[textColor],
        ".Mui-disabled &": {
            color: ({ textColor }) => textColor &&
                {
                    inherit: "inherit",
                    black: "rgba(0,0,0,0.4)",
                }[textColor],
        },
    },
    button_rounded: {
        "&.MuiButton-sizeSmall": {
            borderRadius: 16,
        },
        "&.MuiButton-sizeMedium": {
            borderRadius: 20,
        },
        "&.MuiButton-sizeLarge": {
            borderRadius: 24,
        },
        "&.MuiButton-sizeHuge": {
            borderRadius: 28,
        },
    },
}));
//# sourceMappingURL=ui_button.css.js.map